const data = {
  "hemingway": {
    "entrances": {
      "questionnaire": "Start de keuzehulp"
    },
    "header": {
      "sponsoredArticle": "Gesponsord artikel",
      "writtenBy": "Geschreven door {{author}}",
      "createdAt": "Geschreven op",
      "updatedAt": "Bijgewerkt op"
    },
    "headerProposition": {
      "days": "Dagen",
      "hours": "Uur",
      "minutes": "Minuten",
      "seconds": "Seconden"
    },
    "productCard": {
      "formerPricePrefix": "Adviesprijs",
      "addToCartLabel": "In mijn winkelwagen",
      "mailerLabel": "Houd mij op de hoogte"
    },
    "manufacturersSpecifications": {
      "drawerLabel": "Leveranciersinformatie"
    },
    "productLineComparison": {
      "minutes": "min",
      "priceRange": "Vanaf <lowestPrice /> tot <highestPrice />",
      "priceRangeSingle": "Vanaf <lowestPrice />"
    },
    "inspirational": {
      "productButton": "Bekijk product"
    },
    "newsletter": {
      "emailAddressLabel": "E-mailadres",
      "signUp": "Aanmelden",
      "helperText": "Je kunt je op elk moment afmelden.",
      "emailEmpty": "Er is geen e-mailadres ingevuld.",
      "emailInvalid": "Oeps! Ongeldig e-mailadres. Probeer opnieuw",
      "subscriptionFailedMessage": "Er is iets mis gegaan bij het inschrijven.",
      "successConfirmation": "Je bent nu geabonneerd op de nieuwsbrief",
      "subscriptionSucceededMessage": "Je ontvangt binnen enkele minuten een e-mail op <strong>{{email}}</strong>. Hierin vind je een link om je abonnement te bevestigen."
    },
    "virtualAgent": {
      "new": "nieuw"
    },
    "specialistFooter": {
      "articleAuthorPrefix": "Artikel van {{title}}",
      "specialistLinkPrefixTitle": "Ga naar het artikel"
    },
    "adviceEntrances": {
      "title": "Advies over {{- title}}",
      "intro": "Kan je nog niet kiezen? Bekijk het advies van onze specialist.",
      "entrances": {
        "ariaLabelTitle": "Ga naar pagina {{- title}}"
      }
    },
    "storeInformation": {
      "openingHours": "Openingstijden",
      "hour": "uur",
      "viewStoreOnMap": "Bekijk winkel op de kaart",
      "viewOpeningHours": "Bekijk meer openingstijden",
      "accessibility": "Bereikbaarheid",
      "planYourRoute": "Plan je route",
      "planYourRouteWithGoogleMaps": "Plan je route met Google Maps",
      "openingHoursThisWeek": "Deze week ({{thisWeek}})",
      "openingHoursNextWeek": "Volgende week ({{nextWeek}})",
      "close": "Sluiten",
      "readMore": "Lees meer",
      "copyAddress": "Kopieer adres",
      "infoWindowTitle": "Infovenster"
    },
    "imageEntrances": {
      "readMore": "Bekijk meer artikelen ({{amount}})"
    }
  },
  "articlePanel": {
    "breadcrumbs": {
      "back": "Terug"
    },
    "error": {
      "fact": "Oeps",
      "slogan": "Naar de knoppen.",
      "description": "We kunnen het artikel niet laden. Probeer ‘t opnieuw met de knop hieronder.",
      "linkText": "Opnieuw laden"
    }
  }
};

export default data;